/**
 * Columns of firmware list
 * The value corresponds to the property used to sort on the column.
 */
export enum FirmwareColumns {
  NAME = "name",
  RANGE = "rangeFriendlyName",
  DECLINATION = "declination",
  VERSION = "version",
  BUILD_DATE = "buildDate",
  CREATION_DATE = "createdAt",
  STATUS = "status",
  ACTIONS = "actions",
}
